import React, { useRef, useState, useEffect } from "react"
import { Col, Form, Row } from "react-bootstrap"
import $ from "jquery";
import _ from "lodash"
import { Link } from "gatsby"
import { navigate } from "@reach/router"
import CustomSelect from "../../components/custom-select/custom-select"
import SearchResultBox from "../../components/property-search-bar/SearchResultBox"
import {resiSalesPropertyType, resiLettingsPropertyType, priceminRangeResiSale, pricemaxRangeResiSale, priceminRangeResiRent, pricemaxRangeResiRent, bedroomsRange} from "../../components/common/propertyUtils";
import "./styles/_index.scss"

const mileOptions = [
  { value: "2", label: "+2 Miles" },
  { value: "5", label: "+5 Miles" },
  { value: "10", label: "+10 Miles" },
]

const PropertySearchForm = (props) => {

  const filters = useRef();

  const handleClick = () => {
    filters.current.classList.toggle("is-active");
  }

  // 
  const [areaVal, setAreaVal] = useState('');
  const [ismapview, setIsmapview] = useState(true);

  const [minpriceVal, setMinPriceVal] = useState('');
  const [maxpriceVal, setMaxPriceVal] = useState('');
  const [propertyval, setPropertyVal] = useState('');
  const [salesVal, setSalesVal] = useState('');
  const [bedVal, setBedVal] = useState('');
  const [minPriceList, setMinPriceList] = useState([]);
  const [maxPriceList, setMaxPriceList] = useState([]);

  const [selectedMinPriceValue, setSelectedMinPriceValue] = useState(0);
  const [selectedMaxPriceValue, setSelectedMaxPriceValue] = useState(0);

  // Min price
  const onChangeMinPrice = (e) => {
    setSelectedMinPriceValue(e.value);
  }
  // Min price

  // Max Price
  const onChangeMaxPrice = (e) => {
    setSelectedMaxPriceValue(e.value);
  }
  // Max Price

  // Sales price list
  var minPrice = [];
  var maxPrice = pricemaxRangeResiSale.filter(c => (c.value === "0" || parseInt(c.value) > parseInt(selectedMinPriceValue)));

  priceminRangeResiSale.map(items => parseInt(items.value) < parseInt(selectedMaxPriceValue) && minPrice.push(items));

  if (minPrice.length > 0) {
  } else {
    minPrice.push(priceminRangeResiSale[0])
  }

  if (maxPrice.length > 0) {
  } else {
    maxPrice.push(pricemaxRangeResiSale[0])
  }
  // Sales price list

  // Lettings price list
  var minPriceLettings = [];
  var maxPriceLettings = pricemaxRangeResiRent.filter(c => (c.value === "0" || parseInt(c.value) > parseInt(selectedMinPriceValue)));

  priceminRangeResiRent.map(items => parseInt(items.value) < parseInt(selectedMaxPriceValue) && minPriceLettings.push(items));

  if (minPriceLettings.length > 0) {
  } else {
    minPriceLettings.push(priceminRangeResiRent[0])
  }

  if (maxPriceLettings.length > 0) {
  } else {
    maxPriceLettings.push(pricemaxRangeResiRent[0])
  }
  // Lettings price list

  useEffect(() => {
    // 
    if (_.isEmpty(minPriceList)) {
      if (props.propertyType === "lettings") {
        setMinPriceList(priceminRangeResiRent);
        setMaxPriceList(pricemaxRangeResiRent);
      } else {
        setMinPriceList(priceminRangeResiSale)
        setMaxPriceList(pricemaxRangeResiSale)
      }
    }
    //
    
    // Page when load field in text boxes will same
    const url = typeof window !== 'undefined' ? window.location.href : ''
    let pathUri = url.split("/")
    for (let vi = 1; vi <= pathUri.length; vi++) {
      // check for area
      if (typeof pathUri[vi] === "undefined") {
          continue
      }

      // Property type
      if (pathUri[vi].indexOf("type-") >= 0) {
        setPropertyVal(pathUri[vi].replace("type-", ""))
      }
      // Property type

      // Area
      if ((pathUri[vi].indexOf("in-") == 0) && (pathUri[vi].indexOf("in-sittingbourne") == -1)) {
        setAreaVal(_.upperFirst(pathUri[vi].replace("in-", "")))
      }
      // Area
    
      // Price
        if (
          pathUri[vi].indexOf("between-") >= 0 ||
          pathUri[vi].indexOf("over-") >= 0 ||
          pathUri[vi].indexOf("under-") >= 0
      ) {
          let priceFilt1 = pathUri[vi].split("over-")
          if (priceFilt1[1]) {
            setMinPriceVal(priceFilt1[1])
          }
          let priceFilt2 = pathUri[vi].split("under-")
          if (priceFilt2[1]) {
            setMaxPriceVal(priceFilt2[1])
          }
          let priceFilt3 = pathUri[vi].split("between-")
          if (priceFilt3[1]) {
          let priceFilt4 = priceFilt3[1].split("-and-")
            setMinPriceVal(priceFilt4[0])
            setMaxPriceVal(priceFilt4[1])
          }
      }
      // Price

      // Bedrooms
        if (pathUri[vi].indexOf("-and-more-") >= 0) {
          setBedVal(pathUri[vi].replace("-and-more-bedrooms", ""))
      }
      // Bedrooms

    }
    // Page when load field in text boxes will same
  },[]);

  // Submit search
  const submitSearch = (e) => {
    var areaValue = $(".location-search-results input").val().split(', ').join('-').replace("(", "").replace(")", "").replace(/ /g, "-").replace(/---/g, "-").replace(/'/g, "").toLowerCase();

    var bedroomValue = bedVal ? bedVal : $(".bedroom-input input[type='hidden']").val();
    var buildingValue = propertyval ? propertyval : $(".property input[type='hidden']").val();
    let priceUrl = ""
    if (maxpriceVal || minpriceVal) {
      if (minpriceVal && maxpriceVal && minpriceVal != "0" && maxpriceVal != "0") {
        priceUrl = "between-" + minpriceVal + "-and-" + maxpriceVal
      } else
        if ((minpriceVal == '' || minpriceVal == "0") && maxpriceVal && maxpriceVal != "0") {
          priceUrl = "under-" + maxpriceVal
        }
        else if (minpriceVal && (maxpriceVal == '' || maxpriceVal == "0") && minpriceVal != "0") {
          priceUrl = "over-" + minpriceVal
        }
    }

    var searchFilterResults = "";

    if(areaValue) {
      if(props.propertyMap === "map") {
        if(props.propertyType === "sales") {
          searchFilterResults = "/property-map/for-sale/in-" + areaValue + "/";
        } else {
          searchFilterResults = "/property-map/to-rent/in-" + areaValue + "/";
        }
      } else {
        if(props.propertyType === "sales") {
          searchFilterResults = "/property/for-sale/in-" + areaValue + "/";
        } else {
          searchFilterResults = "/property/to-rent/in-" + areaValue + "/";
        }
      }
    } else {
      if(props.propertyMap === "map") {
        if(props.propertyType === "sales") {
          searchFilterResults = "/property-map/for-sale/in-sittingbourne/";
        } else {
          searchFilterResults = "/property-map/to-rent/in-sittingbourne/";
        }
      } else {
        if(props.propertyType === "sales") {
          searchFilterResults = "/property/for-sale/in-sittingbourne/";
        } else {
          searchFilterResults = "/property/to-rent/in-sittingbourne/";
        }
      }
    }

    if(buildingValue){
      searchFilterResults += "type-" + buildingValue + "/";
    }

    if(bedroomValue && bedroomValue != "0"){
      searchFilterResults += bedroomValue + "-and-more-bedrooms/";
    }

    // if(bedroomValue && bedroomValue == 0){
    //   searchFilterResults += "studio/";
    // }

    if(priceUrl){
      searchFilterResults += priceUrl +"/";
    }
    if(props.sort_by){
      searchFilterResults += 'sortby-'+props.sort_by;
    }
   
    navigate(searchFilterResults);
  }
  // Submit search
  // 
  // Map view
  if (typeof window !== 'undefined' && window.location.pathname.indexOf("/property-map/") == 0) {
    //alert('map-view');
    $('.triggermapview').hide();
  }
  if (typeof window !== 'undefined' && window.location.pathname.indexOf("/property/") == 0) {
    //alert('map-view');
    $('.triggerlistview').hide();
  }
  const mapView = (event) => {
    //alert('test')
    //console.log('qqqqqqqqqqqqqqqqqq')
    //setIsmapview(false);
    if(typeof window !== 'undefined') {
      navigate(window.location.pathname.replace("property", "property-map"))
    }
  }
  // Map View
 // Map view
 const ListView = (event) => {
  //alert('test')
  //console.log('qqqqqqqqqqqqqqqqqq')
  //setIsmapview(true);
  if(typeof window !== 'undefined') {
    navigate(window.location.pathname.replace("property-map", "property"))
  }
}
// Map View
  return (
    <div className="form property-search-form">
      <Form action="javascript:;"  method="post" onSubmit={submitSearch}>
        <Row className="search-row">
          <Col>
            <div className="location-search location-search-results">
              <SearchResultBox placeHolder={`Street, area or postcode`} areaVal={areaVal} />
            </div>
            {/* <Form.Group
              as={Row}
              controlId="property-price"
              className="search-wrapper location-search"
            >
              <Form.Control
                type="search"
                placeholder="Street, area or postcode"
                className="search-input"
                handleChange={(val)=> setAreaVal(val)}
                defaultValue={areaVal}
              />
              <CustomSelect
                options={mileOptions}
                classNamePrefix="mile-select"
                className="mile-select"
                placeholderValue="+2 Miles"
              />
            </Form.Group> */}
          </Col>

          <Col 
          className="filter-col"
          ref={filters}
          >
            <div className="filter-col__extra">
              <button
                type="button"
                className="row-items-wrapper row-items-wrapper--more align-items-center"
                onClick={handleClick}
              >
                <i className="icon-filter"></i>
                <span>More Filters</span>
              </button>
              <a href="javascript:;" onClick={mapView}>
              <button
                type="button"
                className="row-items-wrapper row-items-wrapper--map align-items-center triggermapview"
              >
               
                <i className="icon-location"></i>

                <span>Map view</span>
              </button>
              </a>
              
              
              <a href="javascript:;" onClick={ListView}>
              <button
                type="button"
                className="row-items-wrapper row-items-wrapper--map align-items-center triggerlistview"
              >
               
                <i className="icon-list-view"></i>

                <span>List view</span>
              </button>
              </a>
              
            </div>
            <div className="filter-col__inner">
              <Form.Group
                controlId="property-price"
                className="filter-items-row align-items-center"
              >
                <div className="row-items-wrapper row-items-wrapper--price align-items-center">
                    <i className="icon-price"></i>
                    <div className="select--min">
                      <CustomSelect
                        options={parseInt(selectedMaxPriceValue) === 0 ? minPriceList : (props.propertyType === "sales" ? minPrice : minPriceLettings)}
                        placeholderValue={minpriceVal ? (props.propertyType === "sales" ? "£"+minpriceVal : "£"+minpriceVal+ "pcm") : "Min Price"}
                        DefaultValue={minPriceList.find(obj => obj.value === minpriceVal)}
                        onSelectClick={e => { onChangeMinPrice(e); setMinPriceVal(e.value) }}
                      />
                  </div>
                  <span className="delimeter">to</span>
                    <div className="select--max">
                      <CustomSelect
                        options={parseInt(selectedMinPriceValue) === 0 ? maxPriceList : (props.propertyType === "sales" ? maxPrice : maxPriceLettings)}
                        placeholderValue={maxpriceVal ? (props.propertyType === "sales" ? "£"+maxpriceVal : "£"+maxpriceVal+ "pcm") : "Max Price"}
                        DefaultValue={maxPriceList.find(obj => obj.value === maxpriceVal)}
                        onSelectClick={e => { onChangeMaxPrice(e); setMaxPriceVal(e.value) }}
                      />
                  </div>
                </div>

                <div className="row-items-wrapper row-items-wrapper--bed align-items-center">
                  <i className="icon-bed"></i>
                  <CustomSelect
                    options={bedroomsRange}
                    placeholderValue={bedVal ? bedVal+" +" : "Bedrooms"}
                    value={bedroomsRange.find(obj => obj.value === bedVal)}
                    onSelectClick={e => setBedVal(e.value)}
                  />
                </div>

                <div className="row-items-wrapper row-items-wrapper--type align-items-center">
                  <i className="icon-house-type"></i>
                  <CustomSelect
                    options={props.propertyType === "sales" ? resiSalesPropertyType : resiLettingsPropertyType}
                    placeholderValue={propertyval ? propertyval : "Property Type"}
                    value={props.department === "residential" ? resiSalesPropertyType.find(obj => obj.value === propertyval) : resiLettingsPropertyType.find(obj => obj.value === propertyval)}
                    onSelectClick={e => setPropertyVal(e.value)}
                  />
                </div>

                <div className="d-flex align-items-center property-callout property-search-btn-wrapper m-0">
                  <div className="form__actions m-0">
                    <button className="d-flex btn btn--fill-lightblue w-md-auto property-search-btn" type="submit"><div className="search-text">Submit</div><i className="icon-arrow-right"></i></button>
                  </div>                  
                </div>
              </Form.Group>

              <button
                type="button"
                className="row-items-wrapper row-items-wrapper--map align-items-center"
              >
                <i className="icon-location"></i>
                <span>Map view</span>
              </button>
            </div>
          </Col>
        </Row>
      </Form>
    </div>
  )
}

export default PropertySearchForm
